<template>
    <div class="Support">
        <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
                <el-card class="box-card ticket-card relative">
                    <div slot="header" class="clearfix support-header">
                        <div class="flex cursor-pointer" @click="commitActiveState('NEW_TICKET')">
                            <img src="../assets/images/myAccount/plus.png" width="15">
                            &nbsp;&nbsp;
                            <span class="label-md-bold-black" style="font-size: 0.8rem;">New Support Ticket</span>
                        </div>
                        <div class="flex cursor-pointer left-margin-15" @click="commitActiveState('TRACK_TICKET')">
                            <img src="../assets/images/myAccount/waiting.png" width="15">
                            &nbsp;&nbsp;
                            <span class="label-md-bold-black" style="font-size: 0.8rem;">Check Ticket Status</span>
                        </div>
                    </div>

                    <div class="support-continer">
                        <CreateNewTicket v-if="activeSupportPageState == 'NEW_TICKET'"></CreateNewTicket>
                        <TrackTicket v-if="activeSupportPageState == 'TRACK_TICKET'"></TrackTicket>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <div class="faqs-container top-margin-5" v-if="currentEnvironment.loginModule != 'BlinkX'">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="box-card faq-card">
                        <div class="title">Subscription</div>
                        <div class="top-margin-10">
                            <div class="faq-title" @click="goToLink('FAQ','SUBSCRIPTION')">What subscription options do i have?</div>
                            <div class="faq-title" @click="goToLink('FAQ','SUBSCRIPTION')">What is premium subscription?</div>
                            <div class="faq-title" @click="goToLink('FAQ','SUBSCRIPTION')">What is pro subscription?</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="box-card faq-card">
                        <div class="title">Billing</div>
                        <div class="top-margin-10">
                            <div class="faq-title" @click="goToLink('FAQ','BILLING')">Do i have option of monthly billing?</div>
                            <div class="faq-title" @click="goToLink('FAQ','BILLING')">Can i use paytm for my billing?</div>
                            <div class="faq-title" @click="goToLink('FAQ','BILLING')">Where can i find my invoice?</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="box-card faq-card">
                        <div class="title">Payments</div>
                        <div class="top-margin-10">
                            <div class="faq-title" @click="goToLink('FAQ','PAYMENTS')">What are the other modes of payment?</div>
                            <div class="faq-title" @click="goToLink('FAQ','PAYMENTS')">Unable to do a payment?</div>
                            <div class="faq-title" @click="goToLink('FAQ','PAYMENTS')">Where can i apply for refund?</div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CreateNewTicket from './CreateNewTicket.vue';
import TrackTicket from './TrackTicket.vue';
export default {
    name: 'Support',
    components: {
        CreateNewTicket,
        TrackTicket
    },

    data() {
        return {
            currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},
        }
    },

    methods: {
        commitActiveState(state){
            this.$store.commit('commitSupportPageActiveState', state);
        },

        goToLink(link, key){
            this.$store.commit('commitMyAccountActiveState', link); // commit active state of my account component
            this.$store.commit('commitActivePaymentFAQMenu', key);  // commit active state of payment faq sub link

            // on link select scroll page to top
            var elmnt = document.getElementsByClassName("MyAccount")[0];
            scrollTo(elmnt, 0, 100);
        }
    },

    computed: {
        activeSupportPageState(){
            return this.$store.state.active_support_page_state;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.Support{
    .support-header{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .faqs-container{
        .faq-card{
            height: 150px;
        }
        .title{
            font-size: 0.9rem;
            font-weight: 600;
            color: #000;
        }
        .faq-title{
            font-size: 0.8rem;
            font-weight: 500;
            margin: 10px 0;
            color: $secondary-theme-color;
            cursor: pointer;
        }
    }
}
</style>
<style lang="scss">
.Support{
    .ticket-card{
        .el-card__body{
            min-height: 300px;
        }
    }
}
</style>
